import {
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import FaixasPage from "./faixasPage";
const PgdasBI = React.lazy(() => import("./pgdas"));

interface State {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class SimplesNacional extends React.Component<{}, State> {

  obs = observable({
    selectedTab: "pgdas" as string,
  })

  constructor(props: {}) {
    super(props);
  }

  render() {

    return (

      <Tabs
        id="tabs"
        className="tabsCalculos tabsCentral"
        selectedTabId={this.obs.selectedTab}
        onChange={(tabId) => this.obs.selectedTab = String(tabId)}
        renderActiveTabPanelOnly={true}
      >

        <Tab id="pgdas" title="PGDAS" panel={<PgdasBI />} />
        <Tab id="faixas" title={
          <span className="tab-title">
            Faixas <span className="new-tag-nav-new">Novo</span>
          </span>
        } panel={<FaixasPage />} />
      </Tabs>

    )
  }
}
